import React from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import {
  mergeAreaChartOptions,
  viChartColors,
} from "../../pages/Compare/chartTheme";

const RevenueGrowthCurrenctVsPast: React.FC<any> = ({
  data,
}): React.ReactElement => {
  const { series = [], categories = [] } = data || {};

  const chartData: any = {
    options: mergeAreaChartOptions({
      colors: [viChartColors[2]],
      chart: {
        id: "RevenueGrowthCurrenctVsPast",
      },
      xaxis: {
        categories,
      },
      dataLabels: {
        enabled: true,
        formatter: (value: string) => {
          return `${Number(value).toFixed(2)}%`;
        },
        offsetY: -5,
      },
      legend: {
        showForSingleSeries: true,
      },
    }),
    chart: {
      type: "line",
    },
    series,
  };

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">Revenue Growth: Current-vs-Past (Quartely)</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="area"
        height={550}
      />
    </div>
  );
};

export default RevenueGrowthCurrenctVsPast;
